var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorClothes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.7,35.981l.937-19.022h5.147s1.469-7.273,1.469-7.273l-12.448-3.668-.058.026c-3.676,1.648-7.882,1.639-11.551-.026h0s-12.448,3.668-12.448,3.668l1.469,7.273h5.147l.937,19.022h21.399Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.803,6.053c-.39,2.876-2.855,5.093-5.838,5.093s-5.462-2.229-5.842-5.117"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorClothes);
export default __webpack_public_path__ + "static/media/indoor-clothes.264b7048c24bb80cb857470a29447d00.svg";
export { ForwardRef as ReactComponent };